import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives — the third one it has got
  // wrong, after `sustainability-innovation` and
  // `importance-of-measurement-for-transformation-success`. The reference
  // screenshots for this book's page came from
  // `digitopia.co/impact-labs/ebooks/ai-in-fashion-retail/` on 2026-08-28, so
  // the address is the short one and the whole-title guess was wrong.
  'ai-in-fashion-retail',
  'How Fashion Leaders Are Preparing the Shopping Season',
  `${UPLOADS}/2025/09/ai-in-fashion-retail-400x400.jpg`,
  {
    confirmed: true,
    download: pdf(
      'da9e0c59-0acb-43f3-a26f-f0e87836aac3-Lead the Shopping Season with AI in Fashion Retail.pdf',
    ),
    // Designed as its own written page on 2026-08-28, the fifth after
    // Transform Better, Agentic AI, Sustainability Innovation and Measurement
    // — so the card goes there and `prerender.tsx` skips it, rather than
    // generating this template over the top of it.
    href: '/en/impact-labs/ebooks/ai-in-fashion-retail',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 4
